import './TopSellers.scss';
import Component from './TopSellers.js';
export default Component;
